import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {ColorSketchModule} from 'ngx-color/sketch';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {MapService} from '../api/services/map.service';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {CdkDropListGroup} from '@angular/cdk/drag-drop';

import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TextInputComponent} from '../shared/forms/text-input/text-input.component';
import {TextAreaComponent} from '../shared/forms/text-area/text-area-input.component';
import {SlideToggleInputComponent} from '../shared/forms/slide-select/slide-toggle-input.component';
import {MapStateService} from '../api/services/map-state.service';
import {MapStateDto} from '@maporium-workspace/shared';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'maporium-new-map-state-dialog',
  styleUrls: ['./create-new-tour-dialog.component.scss'],
  template: `
    <div class="w-100 d-flex justify-content-between align-items-center dialog-header">
      <h2 class="align-items-center d-flex m-0 p-0"><span class="material-symbols-rounded me-2">{{data?.id ? 'edit' : 'add_circle'}}</span>
        {{ (data?.id ? 'MAP_STATE_DIALOG.TITLE_UPDATE' : data?.sourceStateId ? 'MAP_STATE_DIALOG.TITLE_CREATE_FROM_CURRENT' : 'MAP_STATE_DIALOG.TITLE_CREATE') | translate }}
      </h2>
      <span class="icon-smap-action-close close-button" mat-dialog-close [matTooltip]="'SHARE_DIALOG.CLOSE_TOOLTIP' | translate"></span>
    </div>

    <div mat-dialog-content>
      <div cdkDropListGroup>
        <form [formGroup]="myForm" class="mb-3">
          <app-text-input [label]="'CREATE_EDIT_SMAP.FIELDS.NAME' | translate" formControlName="name" [autoFocusAndSelect]="true"></app-text-input>
          <app-text-area [label]="'CREATE_EDIT_SMAP.FIELDS.DESCRIPTION' | translate" formControlName="description"></app-text-area>
          <app-slide-toggle-input [label]="'MAP_STATE_DIALOG.FEATURED_LABEL' | translate"
                                  [tooltip]="'MAP_STATE_DIALOG.FEATURED_TOOLTIP' | translate"
                                  formControlName="featured"></app-slide-toggle-input>
        </form>
      </div>

    </div>
    <div mat-dialog-actions class="d-flex justify-content-evenly">
      <button class="dialog-action-btn dialog-action-btn-cancel" mat-dialog-close>{{ 'CREATE_MAP_DIALOG.CANCEL' | translate }}</button>
      <button class="dialog-action-btn dialog-action-btn-primary" (click)="data?.id ? edit() : create()"
              [disabled]="!myForm.valid">{{ (data?.id ? 'CREATE_MAP_DIALOG.UPDATE' : 'CREATE_MAP_DIALOG.CREATE') | translate }}</button>
    </div>
  `,
  imports: [
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    ColorSketchModule,
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    CdkDropListGroup,
    MatExpansionModule,
    MatIconModule,
    MatTooltipModule,
    TextInputComponent,
    TextAreaComponent,
    SlideToggleInputComponent,
    TranslatePipe
  ],
  standalone: true
})

export class CreateNewMapStateDialogComponent implements OnInit {
  myForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MapStateDto & { sourceStateId?: string },
    private matDialogRef: MatDialogRef<CreateNewMapStateDialogComponent>,
    private mapService: MapService,
    private mapStateService: MapStateService,
    private formBuilder: FormBuilder
  ) {
    this.myForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: '',
      featured: false
    });
  }

  ngOnInit(): void {
    if (this.data?.id) {
      this.myForm.patchValue({
        name: this.data.name,
        description: this.data.description,
        featured: this.data.featured
      });
    }
  }




  create() {
    if (this.myForm.valid) {
      const payload: any = {
        name: this.myForm.value.name,
        description: this.myForm.value.description,
        map: this.mapService.getCurrentSelectedMapFromStore() as any,
      };
      if (this.data?.sourceStateId) {
        payload.sourceStateId = this.data.sourceStateId;
      }
      this.mapStateService.createForMap(this.mapService.getCurrentSelectedMapFromStore()?.id, payload).subscribe((state) => {
        this.matDialogRef.close(state);
      });
    }
  }

  edit() {
    if (this.myForm.valid) {
      const payload: MapStateDto = {
        id: this.data.id,
        name: this.myForm.value.name,
        description: this.myForm.value.description,
        featured: this.myForm.value.featured,
        map: this.mapService.getCurrentSelectedMapFromStore() as any,
      }
      this.mapStateService.update(this.data.id as string, payload).subscribe((state) => {
        this.matDialogRef.close(state);
      });
    }
  }

}
